import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Dropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, Button, Collapse, Col, Container, Form, Input, Row } from 'reactstrap';
import { userActions } from '../../actions/index';
import { connect } from 'react-redux';
import { AppSidebarToggler } from '@coreui/react';
import '../layout.scss';
import SideBarData from './SidebarData';
import { signinRedirect, signoutRedirect } from '../../services/userService';
import Select from "react-select";

//Images
import lionLabel from '../../assets/img/brand/sgds-icon.png';
import nhbLogo from '../../assets/img/brand/logo-nhb.png';
import login from '../../assets/img/icons/login.svg';
import userCircle from '../../assets/img/icons/user-circle.svg'
import userImage from '../../assets/img/icons/user.svg'
import greenTick from '../../assets/img/icons/green-tick.svg'
import myaccount from '../../assets/img/icons/myaccount.svg'
import mybooking from '../../assets/img/icons/mybooking.svg'
import notificationIcon from '../../assets/img/icons/notification.svg'
import calendarSm from '../../assets/img/icons/calendar-sm.svg'
import staffAccReq from '../../assets/img/icons/staffAccount-request.svg'
import crossDark from '../../assets/img/icons/cross-dark.svg'
import bars from '../../assets/img/icons/bars.svg'
import modalCross from "../../assets/img/icons/modal-cross.svg"
import searchKhaki from '../../assets/img/icons/Search-khaki.svg'
import searchIcon from '../../assets/img/icons/Search.svg'
import searchHeader from '../../assets/img/icons/SearchHeader.svg'
import logoutDark from '../../assets/img/icons/logout-dark.svg'
import favoriteDark from '../../assets/img/icons/favourite-dark.svg'
import arrowDownIcon from '../../assets/img/icons/arrow_down.svg'
import arrowUpIcon from '../../assets/img/icons/arrow_up.svg'
import venueIcon from '../../assets/img/icons/Venue.svg'
import governmentBuilding from '../../assets/img/icons/government_building.png'
import lock from '../../assets/img/icons/lock.png'

function Header(props) {
	const { StaffsTE, sidebar, getNotificationData, switchMusuem } = props
	const history = useHistory();
	let user = JSON.parse(localStorage.getItem('user'));
	let UserRoleType = localStorage.getItem('UserRoleType');
	let arrayStructure = ["TE", "MF", "MFD", "MC", "MA", "SA"];
	const [sortedArray, setSortedArray] = useState([]);
	const [keyword, setKeyword] = useState("");
	const [GSearch, setGSearch] = useState(false);
	let [IsCollapseOpen, setIsCollapseOpen] = useState(false);
	let [IsRolesOpen, setIsRolesOpen] = useState(false);
	let [CurrentMuseum, setCurrentMuseum] = useState('');
	let [totalCount, setNotiCount] = useState('');
	let [teacherCount, setTeacherCount] = useState('');
	let [museumCount, setMuseumCount] = useState('');
	let [programmeCount, setProgrammeCount] = useState('');
	let [bookingPending, setBookingPending] = useState('');
	let [programmeRejected, setProgrammeRejected] = useState('');
	let [programmeApproved, setProgrammeApproved] = useState('');
	let [sidebarData, setSidebarData] = useState();
	let [showMuseums, setShowMuseums] = useState(false);
	const [museumInput, setMuseumInput] = useState('');
	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [IsHeaderOpen, setIsHeaderOpen] = useState(false);

	let toggleHeaderCollapse = () => setIsHeaderOpen(!IsHeaderOpen);

	let toggleCollapse = () =>{
	if(IsCollapseOpen){
		setIsRolesOpen(false)
	}
	setIsCollapseOpen(!IsCollapseOpen)
	}

	let toggleRoles = () => setIsRolesOpen(!IsRolesOpen)

	function loginSingpass() {
		signinRedirect()
	}
	useEffect(() => {
		if (SideBarData) {
			let newSideBarData = SideBarData

			if (window.innerWidth < 768) {
				let removeItem
				let removeChildren

				newSideBarData && newSideBarData.items && newSideBarData.items.forEach((item, id) => {
					if (item.name === 'General Settings') {
						removeItem = id
						item.children.forEach((children, i) => {
							if (children.name === 'Banners') {
								removeChildren = i
							}
						})
					}
				})

				if (Number.isInteger(removeItem) && Number.isInteger(removeChildren)) {
					newSideBarData.items[removeItem].children.splice(removeChildren, 1)
					if (newSideBarData.items[removeItem].children.length < 1) {
						newSideBarData.items.splice(removeItem, 1)
					}
				}
			}
			setSidebarData(newSideBarData)
		}
	}, [SideBarData])
	useEffect(() => {
		if (!dropdownOpen) setShowMuseums(false)
	}, [dropdownOpen])
	useEffect(() => {
		if (!IsCollapseOpen) setShowMuseums(false)
	}, [IsCollapseOpen])
	useEffect(() => {
		if (!IsRolesOpen) setShowMuseums(false)
	}, [IsRolesOpen])
	useEffect(() => {
		if (user && user.Organization && user.OrganizationId) {
			let data = user.Organization.find((val) => val.Id === user.OrganizationId)
			setCurrentMuseum(data);
			if (data) {
				setMuseumInput({ value: data.Id, label: data.Name })
			}
		}
		let roleArray = []
		if (user && user.Roles) {
			function checkIsExist(data) {
				user.Roles.forEach(val => {
					if (data === val.RoleId) {
						roleArray.push(val)
					}
				})
			}
			arrayStructure.forEach(val => {
				checkIsExist(val);
			})
		}
		setSortedArray(roleArray)

	}, [])

	useEffect(() => {
		if (getNotificationData) {
			let countTotal = getNotificationData.reduce(function (prev, cur) {
				return prev + cur.Count;
			}, 0);
			setNotiCount(countTotal);
			setTeacherCount('')
			setProgrammeCount('')
			setBookingPending('')
			setProgrammeApproved('')
			setProgrammeRejected('')
			getNotificationData.forEach((item, i) => {
				//SA
				if (item.Type === "TeacherRegistration") {
					//setTeacherRegText(item.Type);
					setTeacherCount(item.Count);
				}
				if (item.Type === "MuseumStaffAccountCreated") {
					//setProgramReqText(item.Type);
					setMuseumCount(item.Count);
				}
				if (item.Type === "ProgrammeRequest") {
					setProgrammeCount(item.Count);
				}
				//MC
				if (item.Type === "BookingPending") {
					setBookingPending(item.Count);
				}
				//MA
				if (item.Type === "ProgrammeApproved") {
					setProgrammeApproved(item.Count);
				}
				if (item.Type === "ProgrammeRejected") {
					setProgrammeRejected(item.Count);
				}
			})
		}
		else {
			setNotiCount(0);
			setTeacherCount('')
			setProgrammeCount('')
			setBookingPending('')
			setProgrammeApproved('')
			setProgrammeRejected('')

		}
	}, [getNotificationData]);

	useEffect(() => {
		if (user &&
			(localStorage.getItem('UserRoleType') === 'MC' || localStorage.getItem('UserRoleType') === 'MA' || localStorage.getItem('UserRoleType') === 'SA') &&
			!window.location.pathname.startsWith("/programmepreview")) {
			props.getNotification(UserRoleType, true);
		}
	}, []);

	function handleLogout() {
		signoutRedirect()
	}
	function gotoProfile() {
		scollToTopFunc()
		history.push("/myprofile");
	}
	const toggle = () => {
		setDropdownOpen(!dropdownOpen)
	}

	function gotoFavourite() {
		toggleCollapse()
		scollToTopFunc()
		history.push("/favourites");
        window.location.reload(true);
	}

	function gotoMyBookings() {
		toggleCollapse()
		scollToTopFunc()
		history.push("/mybookings");
	}

	function gotoMuseumSettings(type) {
		props.putNotification(String(UserRoleType), type, "/manageaccounts");
	}
	function gotoProgrammes(type) {
		props.putNotification(String(UserRoleType), type, "/programmes");
	}
	function gotoManageBooking(type) {
		props.putNotification(String(UserRoleType), type, "/managebookingmc");
	}
	function gotoManageTeachers(type) {
		props.putNotification(String(UserRoleType), type, "/accountrequests");
	}
	const viewPopup = () => {
		setGSearch(!GSearch);

	}
	const scollToTopFunc=()=>{
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	}
	const changeUserRole = (roleType) => {
		localStorage.setItem('UserRoleType',roleType);
		if (localStorage.getItem('UserRoleType') === roleType) {
			if (roleType === 'TE') {
				window.location.pathname = '/'
			}
			else {
				window.location.pathname = '/' + localStorage.getItem('UserRoleType')
			}
		}
	}


	const onKeyUp = (e) => {
		if (e.charCode === 13) {
			let data = { searchName: keyword };
			history.push({ pathname: 'globalsearch', state: { data } })
		}
	}
	const onChangeKeyword = (object) => {
		const { value } = object.target;
		setKeyword(value);
	}
	const handleSwitchMuseum = () => {
		window.scrollTo(0,0)
		let data = {
			ActiveOrganizationId: museumInput.value
		}
		switchMusuem(data)
	}
	const handleShowMuseums = () => {
		let data = user.Organization.find((val) => val.Id === user.OrganizationId)
		if (data) {
			setMuseumInput({ value: data.Id, label: data.Name })
		}
		setShowMuseums(!showMuseums)
	}


	const changeClassName = (idName, collapseid, dropdownId, dropdownParentId) => {
		var EleclassName = document.getElementById(idName).className;
		if (EleclassName === 'small icon-arrow-down mr-3') {
			document.getElementById(idName).className = "small icon-arrow-up mr-3";
			document.getElementById(collapseid).className = 'collapse show'
			document.getElementById(dropdownId).className = 'text-left py-3 pl-3 fw-6'
			document.getElementById(dropdownParentId).className = 'menuDropDownOpen'
		}
		else {
			document.getElementById(idName).className = "small icon-arrow-down mr-3";
			document.getElementById(collapseid).className = 'collapse'
			document.getElementById(dropdownId).className = 'text-left py-3 pl-3'
			document.getElementById(dropdownParentId).className = ''
		}

	}
	const showMuseumDOM = (type) => {
		return (<>
			{UserRoleType !== "TE" && UserRoleType !== "SA" && user?.Organization?.length > 1 &&
				<>
					{showMuseums && type === 'desktop' && <div className="dd-header">My Museums</div>}
					<div className="MuseumSwitcher" onClick={handleShowMuseums}>
						{!showMuseums ?
							<>
								<div className="dd-item-icon d-none d-md-block"><img src={venueIcon} alt='venue' /></div>
								<div className="dd-item fw-5 d-none d-md-block">{CurrentMuseum.Name}
									<div className="fs-12 fw-7">Tap to switch museum</div>
								</div>
								<div className='collapseItem d-block d-md-none'>
									<span className=" ml-2"><img src={venueIcon} alt='calendar' /></span>
									<span className="font-weight-bold pl-2">{CurrentMuseum.Name}
										<div className="font-weight-light ml-4 pl-2">Tap to switch museum</div>
									</span>
								</div>
							</>
							:
							<div className={type === 'desktop' ? 'fs-12 fw-7' : 'fs-12 fw-7 ml-3'}>
								<i className="fa fa-arrow-left mr-2" aria-hidden="true"></i>
								Tap to go back
							</div>}
					</div>

					<DropdownItem divider className={type === 'desktop' ? 'm-0' : 'mx-3 mb-0 mt-2'} />
					<Collapse className='' isOpen={showMuseums} aria-expanded="false">
						<DropdownItem text className={type === 'desktop' ? 'p-0' : 'py-0 px-3'}>
							<div className='p-2 d-none d-md-block' >
								<div className="dd-item-icon"><img src={venueIcon} alt='venue' /></div>
								<div className="dd-item mb-2 fw-6"> Select Museum</div>
							</div>
							<div>
								<div className='collapseItem d-block d-md-none'>
									<span className=" ml-2"><img src={venueIcon} alt='calendar' /></span>
									<span className="font-weight-bold pl-2">Select Museum</span>
								</div>

								<Select
									value={museumInput}
									label='React Select'
									placeholder='Select Museum'
									onChange={(e) => setMuseumInput(e)}
									options={user?.Organization?.map(obj => {
										let { Id: value, Name: label } = obj
										return { value, label }
									})}
									name='Museum'
									id='Museum'
									isSearchable={true}
									menuIsOpen={true}
									theme={(theme) => ({
										...theme,
										borderRadius: 0,
										colors: {
											...theme.colors,
											primary: '#c15151',
										},
									})}
								/>
							</div>
							<div className='text-center my-2'>
								<Button className={type === 'desktop' ? 'button-style9' : 'button-style6'} disabled={!museumInput || museumInput?.value === CurrentMuseum?.Id} onClick={handleSwitchMuseum}>Switch Museum</Button>
							</div>
						</DropdownItem>
					</Collapse>
				</>}
		</>)
	}
	return (
		<React.Fragment>
			<div className="agency-header text-left">
				<div className='d-block mb-1 pt-1 container '>
					<img
						src={lionLabel}
						alt="Lion Head Symbol" className="mr-3"
					/>
					<a href="https://www.gov.sg/" target="_blank" rel="noopener noreferrer">A Singapore Government Agency Website</a>
					<span className={IsHeaderOpen ? "sgds-masthead__toggle sgds-masthead__toggle--active" : "sgds-masthead__toggle"}
						onClick={() => toggleHeaderCollapse()}
					>
						<span>
							How to identify
						   <span class="sgds-masthead__icon fa fa-angle-down"> </span>
						</span>
					</span>
				</div>

				<Collapse className='' isOpen={IsHeaderOpen} aria-expanded="false">
					<div className="sgds-masthead__content">
						<div className="container">
							<div className="banner-content">
								<div className="banner-content__wrap">
									<img className="banner-icon" src={governmentBuilding} alt="Building" />
									<div className="banner-content-text-container">
										<strong className="banner-content-title">Official website links end with .gov.sg</strong>
										<p>
											Government agencies communicate via <strong>.gov.sg</strong> websites
									<span className="d-block">
												(e.g. go.gov.sg/open). <a
													class="banner-content-text sgds-masthead__button-link" href="https://go.gov.sg/trusted-sites" target="_blank" rel="noreferrer">
													Trusted websites
											<span className="fa fa-external-link"></span>
												</a>
											</span>
										</p>
									</div>
								</div>
							</div>

							<div className="banner-content">
								<div className="banner-content__wrap">
									<img className="banner-icon" src={lock} alt="Lock" />
									<div className="banner-content-text-container">
										<strong className="banner-content-title">Secure websites use HTTPS</strong>
										<p>
											Look for a <strong>lock</strong> (<img className="inline-banner-icon" src={lock} alt="Lock" />)
                                    or https:// as an added precaution. Share sensitive information only on official, secure websites.
                                </p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</Collapse>
			</div>

			{sidebar && (
				<div className='d-none d-md-inline'>
					<AppSidebarToggler className="d-lg-none mb-" display="md" mobile aria-label="search"></AppSidebarToggler>
					<AppSidebarToggler className="d-md-down-none mb-5" display="lg" aria-label="search"></AppSidebarToggler>
				</div>
			)}
			<div className="container pt-1" style={{ paddingBottom: '15px' }} >
				<a href="https://www.bookmuseums.nhb.gov.sg/" title="NHB Logo">
					<img
						src={nhbLogo}
						alt="NHB logo"
						tabIndex="0"
						className='NHBLogo'
					/>
				</a>

				{user && (
					<Nav className="ml-auto" navbar >
						<Dropdown isOpen={dropdownOpen} toggle={toggle} nav direction="down" className='d-none d-md-block headerDropdown'>
							<DropdownToggle nav>
								<div className="user-icon">
									<img src={login} alt='user' />
								</div>

								<div className="pl-2 user-name">
									<span className='fw-5'>
										{user.FirstName}
										<img src={arrowDownIcon} alt='arrow-down' className="pl-2 small icon-arrow-down" />
										<span className="role">{UserRoleType}  {!CurrentMuseum?.Code ? "" : " " + CurrentMuseum.Code}
										</span>
									</span>
								</div>
							</DropdownToggle>

							<DropdownMenu right >
								<Collapse className='' isOpen={!showMuseums} aria-expanded="false">
									{sortedArray && UserRoleType !== "TE" && <>
										<div className="dd-header">My Role(s)</div>

										{sortedArray.map((item, i) =>
											<DropdownItem key={i} onClick={() => changeUserRole(item.RoleId)}>
												<div className="dd-item-icon">{UserRoleType === item.RoleId ? <img src={userCircle} alt='user' /> : <img src={userImage} alt='user' />}</div>
												<div className={UserRoleType === item.RoleId ? "dd-item" : "dd-item fw-5"}>  {item.RoleName} ({item.RoleId}) {UserRoleType === item.RoleId ? <img src={greenTick} alt='green tick' /> : ''}</div>
											</DropdownItem>)}
										<DropdownItem divider className='m-0' />
									</>}
								</Collapse>
								{showMuseumDOM('desktop')}
								<Collapse className='' isOpen={!showMuseums} aria-expanded="false">

									<DropdownItem onClick={gotoProfile}>
										<div className="dd-item-icon"><img src={myaccount} alt='user' /></div>
										<div className="dd-item"> My Account
											<span>Update your personal information</span>
										</div>
									</DropdownItem>
									<DropdownItem onClick={gotoFavourite}>
										<div className="dd-item-icon"><img src={favoriteDark} alt='heartine' /></div>
										<div className="dd-item"> Favourites
											<span>View your favourited programmes here</span>
										</div>
									</DropdownItem>
									{(UserRoleType === "TE" || StaffsTE.includes(UserRoleType)) && <DropdownItem onClick={gotoMyBookings}>
										<div className="dd-item-icon"><img src={mybooking} alt='calendar' /></div>
										<div className="dd-item"> My Bookings
											<span>Seeing upcoming and past bookings,<br />modify booking,cancel bookings</span>
										</div>
									</DropdownItem>}
									<DropdownItem onClick={handleLogout}>
										<div className="dd-item-icon"><img src={logoutDark} alt='logout' /></div>
										<div className="dd-item"> Logout</div>
									</DropdownItem>
								</Collapse>

							</DropdownMenu>

							{/* </UncontrolledDropdown> */}
						</Dropdown>
						{((UserRoleType === "SA"||UserRoleType === "MA"||UserRoleType === "MC")&&window.location.pathname !== "/programmepreview") && <UncontrolledDropdown nav className="notification-wrap" direction="down">
							<DropdownToggle nav >
								<div className="notification-icon">
									<img alt="bell" src={notificationIcon} />
									{totalCount !== "" && totalCount !== 0 && <span className="badge-icon">{totalCount}</span>}
								</div>
							</DropdownToggle>
							<DropdownMenu right>
								<div className="dd-header">You have {totalCount ? totalCount : "no"} notifications</div>
								{programmeCount && <DropdownItem onClick={() => gotoProgrammes('ProgrammeRequest')}>
									<div className="dd-item-icon programme"><img alt="calendar" src={calendarSm} /></div>
									<div className="dd-item individualNotification"> <div className='individualCount'>{programmeCount}</div> Museum programme {museumCount === 1 ? "request" : "requests"}</div>
								</DropdownItem>}
								{teacherCount && <DropdownItem onClick={() => gotoManageTeachers('TeacherRegistration')}>
									<div className="dd-item-icon teacherAccount"><img alt="user" src={staffAccReq} /></div>
									<div className="dd-item individualNotification"> <div className='individualCount'>{teacherCount}</div> Teacher account {teacherCount === 1 ? "request" : "requests"}</div>
								</DropdownItem>}
								{museumCount && <DropdownItem onClick={() => gotoMuseumSettings('MuseumStaffAccountCreated')}>
									<div className="dd-item-icon staffAccount"><img alt="user" src={staffAccReq} /></div>
									<div className="dd-item individualNotification"> <div className='individualCount'>{museumCount}</div> Staff account {museumCount === 1 ? "request" : "requests"}</div>
								</DropdownItem>}
								{programmeApproved && <DropdownItem onClick={() => gotoProgrammes('ProgrammeApproved')}>
									<div className="dd-item-icon programme"><img alt="calendar" src={calendarSm} /></div>
									<div className="dd-item individualNotification"> <div className='individualCount'>{programmeApproved}</div> Programme {programmeApproved === 1 ? "Request" : "Requests"} approved.</div>
								</DropdownItem>}
								{programmeRejected && <DropdownItem onClick={() => gotoProgrammes('ProgrammeRejected')}>
									<div className="dd-item-icon programme"><img alt="calendar" src={calendarSm} /></div>
									<div className="dd-item individualNotification"> <div className='individualCount'>{programmeRejected}</div> Programme {programmeRejected === 1 ? "Request" : "Requests"} rejected</div>
									<div className='dd-item'>Review details</div>
								</DropdownItem>}
								{bookingPending && <DropdownItem onClick={() => gotoManageBooking('BookingPending')}>
									<div className="dd-item-icon programme"><img alt="calendar" src={calendarSm} /></div>
									<div className="dd-item individualNotification"> <div className='individualCount'>{bookingPending}</div> Pending {bookingPending === 1 ? "Booking" : "Bookings"}</div>
								</DropdownItem>}
							</DropdownMenu>
						</UncontrolledDropdown>}
					</Nav>
				)}
				<img aria-expanded="false" className='d-block d-md-none ml-2 mt-2 accordianheader' src={IsCollapseOpen ? crossDark : bars} onClick={() => toggleCollapse()} alt='accordian' />
				<Nav className='NavItemsMD'>
					{!user && (
						<NavItem className="d-none d-md-inline mr-4">
							<Button className="button-style6" onClick={loginSingpass}>
								Login
							</Button>
						</NavItem>
					)}
					{(UserRoleType === "TE") &&
						<NavItem className='d-none d-md-block ml-4'>
							<Button onClick={e => viewPopup()} className="nav-link plainBtn px-1 mt-1" aria-label="search">
								{GSearch ? <img src={modalCross} alt='cross' /> : <img src={searchHeader} alt='search' />}

							</Button>
						</NavItem>
					}
					{(!user) &&
						<NavItem className='d-none d-md-inline'>
							<Button onClick={e => viewPopup()} className="nav-link  px-1 mt-1 plainBtn searchCollapse" aria-label="search">
								{GSearch ? <img src={modalCross} alt='cross' /> : <img src={searchHeader} alt='search' />}
							</Button>
						</NavItem>
					}
				</Nav>
			</div>
			{GSearch &&
				<div className="search-bar">
					<Container>
						<Form>
							<Row>
								<Col>
									<div className="MC-refno">
										<img src={searchIcon} alt='search' className="pl-2 icon-magnifier" />
										<Input
											type="text"
											name="RefNumber"
											placeholder="Enter a Keyword * "
											onChange={onChangeKeyword}
											className=" mr-4 searchGlobal"
											value={keyword}
											onKeyPress={e => onKeyUp(e)}
											autoFocus />
									</div>
								</Col>
							</Row>
						</Form>
					</Container>
				</div>
			}
			<Collapse className=' d-md-none w-100 bg-white text-left mobilemenuBar ' isOpen={IsCollapseOpen} aria-expanded="false">
				{(!user || UserRoleType === 'TE') &&
					<div className='collapseItem mt-0'>
						<hr className='mt-0 mb-3' />
						<Form>
							<Row>
								<Col>
									<img className='pl-3' src={searchKhaki} alt='magnifier' />
									<input
										type="text"
										name="RefNumber"
										placeholder='Search'
										onChange={onChangeKeyword}
										className="dd-item searchBox ml-2"
										value={keyword}
										onKeyPress={e => onKeyUp(e)}
										autoFocus
									/>
								</Col>
							</Row>
						</Form>
						<hr className='mt-3' />
						{!user && <div className="mt-2 ml-3">
							<Button className="button-style6 loginBtn" onClick={loginSingpass}>
								Login
							</Button>
						</div>}
					</div>
				}
				{UserRoleType !== "TE" && user && <React.Fragment>
					<Row className="ml-3 user-name my-4 pb-1">
						<Col xs='1' className='pl-0'><img src={userCircle} alt='magnifier' /></Col>
						<Col xs='9' className=''> 	<div>{user.FirstName}</div>
							<div className="role">{UserRoleType}  {!CurrentMuseum?.Code ? "" : " " + CurrentMuseum.Code}</div>
						</Col>
						<Col xs='2' onClick={e => toggleRoles()}>{!IsRolesOpen ? <img src={arrowDownIcon} alt='arrow-down' className="pl-2 small icon-arrow-down pull-right mr-3" /> :
							<img src={arrowUpIcon} alt='arrow-up' className="pl-2 small icon-arrow-up pull-right mr-3" />}</Col>
					</Row>
					<Collapse className=' d-md-none w-100 bg-white text-left headerDropdown' isOpen={IsRolesOpen} aria-expanded="false">
						<div className='ml-3 mr-3  fw-6'>{showMuseums ? 'My Museums' : 'My Role(s)'}</div>
						<hr className={showMuseums ? 'ml-3 mr-3 mt-0 mb-2' : 'ml-3 mr-3 mt-0'} />
						<Collapse className='' isOpen={!showMuseums} aria-expanded="false">
							{sortedArray && UserRoleType !== "TE" &&
								sortedArray.map((item, i) =>
									<div key={i} onClick={() => changeUserRole(item.RoleId)} className='ml-3 mr-3 mb-3'>
										<div className={UserRoleType === item.RoleId ? "fw-6" : ""}>  {item.RoleName} ({item.RoleId}) {UserRoleType === item.RoleId ? <img src={greenTick} className='pull-right' alt='green tick' /> : ''}</div>
									</div>)}
							<hr className='ml-3 mr-3 mb-0' />
						</Collapse>
						{showMuseumDOM()}
						<Collapse className='' isOpen={!showMuseums} aria-expanded="false">
							<div className='collapseItem ml-2' onClick={gotoProfile}>
								<span className=" ml-2"><img src={myaccount} alt='user' /></span>
								<span className="font-weight-bold pl-2">My Account
									<div className="font-weight-light ml-4 pl-2">Update your personal information</div>
								</span>
							</div>
							<div className='collapseItem ml-2' onClick={gotoFavourite}>
								<span className=" ml-2"><img src={favoriteDark} alt='favourite' /></span>
								<span className="font-weight-bold pl-2">My Favourites
									<div className="font-weight-light ml-4 pl-2">View your favourited programmes here</div>
								</span>
							</div>
							{StaffsTE.includes(UserRoleType) &&
								<div className='collapseItem ml-2' onClick={gotoMyBookings}>
									<span className=" ml-2"><img src={mybooking} alt='calendar' /></span>
									<span className="font-weight-bold pl-2">My Bookings
										<div className="font-weight-light ml-4 pl-2">Seeing upcoming and past bookings,modify booking,cancel bookings</div>
									</span>
								</div>}
							<div className='collapseItem mb-3 ml-2' onClick={handleLogout}>
								<span className="ml-2"><img alt="logout" src={logoutDark} /></span>
								<span className="font-weight-bold pl-2"> Logout</span>
							</div>
						</Collapse>
					</Collapse>
				</React.Fragment>}
				<Collapse className='' isOpen={!showMuseums} aria-expanded="false">
					{UserRoleType === "TE" && <React.Fragment>
						<div className='collapseItem' onClick={gotoProfile}>
							<div className="dd-item-icon ml-2"><img alt="user" src={myaccount} /></div>
							<div className="dd-item font-weight-bold pl-2"> My Account
								<div className="font-weight-light">Update your personal information</div>
							</div>
						</div>
						<div className='collapseItem' onClick={gotoFavourite}>
							<div className="dd-item-icon ml-2"><img alt="favourite" src={favoriteDark} /></div>
							<div className="dd-item font-weight-bold pl-2"> Favourites
								<div className="font-weight-light">View your favourited programmes here</div>
							</div>
						</div>

						<div className='collapseItem' onClick={gotoMyBookings}>
							<div className="dd-item-icon ml-2"><img src={mybooking} alt='calendar' /></div>
							<div className="dd-item font-weight-bold pl-2"> My Bookings
								<div className="font-weight-light">Seeing upcoming and past bookings,modify booking,cancel bookings</div>
							</div>
						</div>

						<div className='collapseItem mb-3' onClick={handleLogout}>
							<div className="dd-item-icon ml-2"><img alt="logout" src={logoutDark} /></div>
							<div className="dd-item font-weight-bold pl-2"> Logout</div>
						</div>
					</React.Fragment>}
					{sidebarData && sidebarData.items.map((item, id) => {
						return (
							<div className='mobileSidebarMenu' key={id}>
								<div className=''>{(item.children) ?
									<div className='' id={`dropdownParent${id}`}>
										<div className='text-left py-3 pl-3' id={`dropdown${id}`} onClick={() => changeClassName(`dropdownArrow${id}`, `collapseMenu${id}`, `dropdown${id}`, `dropdownParent${id}`)}>{item.name} <span className='pull-right' ><img id={`dropdownArrow${id}`} src={arrowDownIcon} alt='icon-arrow-down' className="small icon-arrow-down mr-3" /></span></div>
										<Collapse id={`collapseMenu${id}`} >
											{item.children && item.children.map((children, i) => {
												return (
													<div key={i} className={history.location.pathname === children.url ? 'text-left py-3 pl-3 childrenActive' : 'text-left pl-3 py-3'} ><a href={children.url} >{children.name}</a></div>
												)
											})}
										</Collapse >
									</div>
									:
									<div className={history.location.pathname === item.url ? 'itemActive py-3 pl-3' : 'py-3 pl-3'}><a href={item.url} aria-current="page" >{item.name}</a></div>}
								</div>
							</div>
						)

					})}
				</Collapse>
			</Collapse>
		</React.Fragment>
	);
}

function mapState(state) {
	return {
		getNotificationData: state.getnotification.gotnotificationdetails,
		putNotificationData: state.putNotification.putNotifications,
		StaffsTE: state.TeacherBookingStaff,
	};
}

const actionCreators = {
	login: userActions.login,
	logout: userActions.logout,
	getNotification: userActions.getNotification,
	putNotification: userActions.putNotification,
	switchMusuem: userActions.switchMusuem,

};

export default connect(mapState, actionCreators)(Header);